var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Dialog',{attrs:{"show":_vm.showDialog,"cancel":_vm.cancel,"confirm":_vm.confirm,"title":"Select stop time"}}),_c('ReportClarificationAlert'),_c('div',[_c('DashboardOverview')],1),(_vm.permissions)?_c('ReportTaskDashboard'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }